import $ from 'jquery';
import {PanoViewer} from "@egjs/view360";
import { gsap } from "gsap";

function toRadian(deg: number) {
  return deg * Math.PI / 180;
}
function getHFov(fov: number, rect: DOMRect) {
  var width = rect.width;
  var height = rect.height;
  return Math.atan(width / height * Math.tan(toRadian(fov) / 2)) / Math.PI * 360;
}
function rotate(point: number[], deg: number) {
  var rad = toRadian(deg);
  var cos = Math.cos(rad);
  var sin = Math.sin(rad);

  return [cos * point[0] - sin * point[1], sin * point[0] + cos * point[1]];
}

export class View360 {
  private viewer: PanoViewer;
  private hotspots: any[];
  private element: HTMLElement;
  private container: HTMLElement | null;
  private currentPage: string = '1';
  private isIntro: boolean = false;
  private introTween: gsap.core.Tween;

  constructor(element: HTMLElement) {
    this.element = element;
    this.container = element.querySelector('.viewer-container');
    this.hotspots = Array.prototype.slice.call(element.querySelectorAll(".hotspot"));
    this.viewer = new PanoViewer(this.container!, {
      image: element.getAttribute('view360-background')!,
      useZoom: false,
      projectionType: 'panorama',
    })
    .on("ready", this.onReady.bind(this))
    .on("viewChange", this.onViewChange.bind(this));
  }

  private onReady() {
    this.isIntro = true;
    const that = this;
    const startYaw = 150;

    this.onResize();

    this.container?.addEventListener('mousedown', this.introCanceler.bind(this));
    this.container?.addEventListener('touchstart', this.introCanceler.bind(this));
    this.viewer.lookAt({
      yaw: startYaw,
    }, 0);
    setTimeout(function () {
      // viewer.lookAt({
      //     yaw: 360,
      // },30000);
      // setHotspotOffsets(viewer);
      var obj =  {yaw: startYaw};
      that.element.classList.add('loaded');
      that.introTween = gsap.to(obj, {
        yaw: -134,
        duration: 120,
        ease: "power2.out",
        onUpdate: function(){
          that.viewer.lookAt({
            yaw: obj.yaw
          });

        },
        onComplete: function(){
          that.isIntro = false;
          that.setHotspotOffsets(obj);
        }
      });
    }, 1000);

    window.addEventListener("resize", this.onResize.bind(that));
  }

  private onResize() {
    let header = document.getElementsByClassName('fusion-header-wrapper')[0];

    this.element.style.height = (
      window.innerWidth < 768 ? (window.innerHeight - header.clientHeight) :
      Math.min(
        window.innerWidth * 0.66648,
        window.innerHeight - header.clientHeight
      )
      ) + 'px';

    this.viewer.updateViewportDimensions();
    this.setHotspotOffsets({yaw: this.viewer.getYaw()});
  }

  private onViewChange(data: any) {
    this.setHotspotOffsets(data);
  }

  private setHotspotOffsets(data: any) {
    const holder = this;
    this.hotspots.filter(function (hotspot) {
      return hotspot.getAttribute("data-page")! === holder.currentPage;
    }).forEach(function (hotspot) {
      holder.setHotspotOffset(hotspot);

      var yaw = parseFloat(hotspot.getAttribute("data-yaw")!) % 360;

      if (Math.abs(yaw - data.yaw) < 5 && holder.isIntro) {
        if( !hotspot.classList.contains('active')) {
          hotspot.classList.add('active');
        }
      } else {
        if( hotspot.classList.contains('active')) {
          hotspot.classList.remove('active');
        }
      }
    });
  }

  private introCanceler() {
    if(this.isIntro) {
      this.introTween.kill();
      this.isIntro = false;
    }

    this.container?.removeEventListener('mousedown', this.introCanceler);
  }

  private setHotspotOffset(hotspot:HTMLElement) {
    var oyaw = this.viewer.getYaw();
    var opitch = this.viewer.getPitch();
    var yaw = parseFloat(hotspot.getAttribute("data-yaw")!);
    var pitch = parseFloat(hotspot.getAttribute("data-pitch")!);
    var deltaYaw = yaw - oyaw;
    var deltaPitch = pitch - opitch;

    if (deltaYaw < -180) {
        deltaYaw += 360;
    } else if (deltaYaw > 180) {
        deltaYaw -= 360;
    }
    if (Math.abs(deltaYaw) > 90) {
        hotspot.style.transform = "translate(-1000px, -1000px)";
        return;
    }
    var radYaw = toRadian(deltaYaw);
    var radPitch = toRadian(deltaPitch);

    var fov = this.viewer.getFov();
    var hfov = getHFov(fov, this.container!.getBoundingClientRect());

    var rx = Math.tan(toRadian(hfov) / 2);
    var ry = Math.tan(toRadian(fov) / 2);


    var point = [
        Math.tan(-radYaw) / rx,
        Math.tan(-radPitch) / ry,
    ];

    // Image rotation compensation
    // The original image is about 10 degrees tilted.
    point = point.map(function (p) {
        return p * Math.cos(15 / 180 * Math.PI);
    });
    // point[1] = rotate(point, deltaYaw > 0 ? -10 : 10)[1];

    // point[0] /= 1.05;
    const viewerAny = this.viewer as any;
    var left = viewerAny._width / 2 + point[0] * viewerAny._width / 2;
    var top = viewerAny._height / 2 + point[1] * viewerAny._height / 2;

    hotspot.style.transform = "translate(" + left + "px, " + top + "px) translate(-50%, -50%)";
}
}

function initView360() {
  const $viewers = $('div.viewer');

  if($viewers.length > 0) {
    $viewers.each((index, element) => {
      new View360(element);
    });
  }
}

export default {
  init: initView360,
}